// Tremor Card [v0.0.2], adapted: Papel surface tokens, radix-ui Slot. Slick (27/09/2026) : 12 px, anneau
// de 1 px (border très clair) et ombre longue et douce (shadow-papel).
import * as React from "react";
import { Slot } from "radix-ui";
import { cx } from "./utils";

interface CardProps extends React.ComponentPropsWithoutRef<"div"> {
  asChild?: boolean;
}

const Card = React.forwardRef<HTMLDivElement, CardProps>(({ className, asChild, ...props }, forwardedRef) => {
  const Component = asChild ? Slot.Root : "div";
  return (
    <Component
      ref={forwardedRef}
      className={cx(
        // 06/10/2026 : mismo aspecto que la Card radix-nova (anillo 10 %, radio xl, sombra mínima).
        "relative w-full rounded-xl p-5 text-left text-sm shadow-xs ring-1 ring-foreground/10",
        "bg-card text-card-foreground",
        className,
      )}
      {...props}
    />
  );
});

Card.displayName = "Card";

export { Card, type CardProps };
